import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import InitiativeDetailTable from './initiativeDetailTable';
import BasicDetailDrillDown from 'components/basicDetailDrillDown';
import InitiativeEdit from '../initiativeMaintenance/initiativeEdit';
import { getInitiativeDisplayData } from 'services/initiativeService';
import SelectByIdModal from 'components/selectByIdModal';
import { sameByIdValue } from 'services/arrayService';
import {
    onEditInitiative,
    onInitiativeSelect,
    showInitiativeLoader,
    onInitiativeProductUpdate,
    onFetchSelectProductData,
    onDeleteInitiative,
} from 'actions/initiative';
import DeleteItemCheck from 'components/deleteItemCheck';
// import { TIGHT_FIT_PARAM } from 'constants/System';

const InitiativeDetail = () => {
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const allProducts = useSelector(state => state.products.allProduct);
    const selectedOrg = useSelector(state => state.orgs.selectedOrg);
    const selectedInitiative = useSelector(state => state.initiatives.selectedInitiative);
    const productSelectionList = useSelector(state => state.initiatives.productSelectionList);
    const [selectedProducts, setSelectedProducts] = useState();
    const [displayData, setDisplayData] = useState();

    useEffect(() => {
        // TODO - do not fetch if no selected initiative
        // update the selectedProducts
        setSelectedProducts([]);
        const products = sameByIdValue(allProducts, selectedInitiative?.products);
        setSelectedProducts(products);
        const fetchDisplayData = async () => {
            const result = await getInitiativeDisplayData(selectedInitiative?.id, selectedOrg?.id);
            setDisplayData(result);
        };
        fetchDisplayData();
    }, [selectedInitiative]);

    const mainIcon = () => {
        // TODO pass in type to change the icon on the detail tab
        // if (type && type.toLowerCase() === 'high') {
        //     return 'stream';
        // }
        // if (type && type.toLowerCase() === 'medium') {
        //     return 'compact';
        // }
        // if (type && type.toLowerCase() === 'low') {
        //     return 'module';
        // }
        return 'dashboard';
    };

    if (selectedInitiative) {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-7 col-12">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h2 className="card-heading">{displayData?.name}</h2>
                                </div>
                                <div>
                                    <SelectByIdModal
                                        modalTitle={<IntlMessages id="initiative.products" />}
                                        onUpdateHandler={onInitiativeProductUpdate}
                                        onSelectRowHandler={onInitiativeSelect}
                                        onClickButtonHandler={onFetchSelectProductData}
                                        selectLoader={showInitiativeLoader}
                                        data={productSelectionList}
                                        width={width}
                                        actionButtonTextId={<IntlMessages id="initiative.products" />}
                                    />
                                    <DeleteItemCheck
                                        id={selectedInitiative?.id}
                                        onConfirm={onDeleteInitiative}
                                        alertMessage={<IntlMessages id="initiative.deleteInitiative" />}
                                    />
                                    <Button size="sm" color="primary" onClick={() => dispatch(onEditInitiative(selectedInitiative))}>
                                        <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                        <span>{<IntlMessages id="label.edit" />}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className="jr-card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                            <p>
                                                {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                <i className={`detail-icon text-blue-grey zmdi zmdi-view-${mainIcon()} zmdi-hc-fw`} />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 text-center text-sm-left">
                                        <InitiativeDetailTable displayData={displayData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <InitiativeEdit />
                    </div>

                    <div className="col-md-5">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <BasicDetailDrillDown entries={selectedProducts} title={<IntlMessages id="initiative.products" />} />
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="jr-card jr-card-full-height">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">Please select an entry to display details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default InitiativeDetail;


// WEBPACK FOOTER //
// ./components/Agile/initiative/initiativeDetail/index.js